import { OrganizationView } from "@daveyplate/better-auth-ui";
import { createFileRoute, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/organization/settings")({
	component: OrganizationSettingsPage,
	ssr: false,
});

function OrganizationSettingsPage() {
	const pathname = useLocation({ select: (location) => location.pathname });

	return (
		<div className="container mx-auto px-4 py-8">
			<OrganizationView pathname={pathname} />
		</div>
	);
}
